module.exports = __webpack_public_path__ + "img/arrow_to.9910ff8d.svg";